module.exports = __webpack_public_path__ + "img/nadvorie.b1982605.jpg";